import type PlantModel from "Models/Plant";
import Modal from "react-modal";
import ModalStyle from "Assets/ModalStyle";

interface PlantOverrideSettingsModalProps {
  isOpen: boolean;
  parentPlant?: PlantModel;
  onClose: () => void;
  onOverride: () => void;
}

const PlantOverrideSettingsModal = ({
  isOpen,
  parentPlant,
  onClose,
  onOverride,
}: PlantOverrideSettingsModalProps) => (
  <Modal
    style={{
      ...ModalStyle.defaultStyle,
      overlay: {
        ...ModalStyle.defaultStyle.overlay,
        zIndex: 1100,
      },
    }}
    ariaHideApp={false}
    isOpen={isOpen}
    onRequestClose={onClose}
  >
    <h2 className="text-lg py-5 font-semibold items-center justify-center flex">
      Override Plant Settings?
    </h2>
    <p className="plant-info">
      This action will replace the current plant settings with the settings from{" "}
      {parentPlant?.name}
    </p>
    <p className="plant-info">Are you sure you want to proceed?</p>
    <div className="flex pt-10">
      <button onClick={onClose} className="ml-auto btn bg-gray-light mr-5">
        Cancel
      </button>
      <button onClick={onOverride} className="btn btn-green mr-auto">
        Override
      </button>
    </div>
  </Modal>
);

export default PlantOverrideSettingsModal;
